import * as React from 'react';
import { SVGProps } from 'react';

const IconDropSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 10.546C1 6.455 6.564 1 6.564 1s1.844 1.807 3.409 4.121c-.513.94-.88 1.926-.88 2.821 0 1.878 1.227 3.351 2.907 3.814C11.452 14.261 9.227 16 6.564 16 3.491 16 1 13.683 1 10.546z" />
    <path d="M11.435 6.448C11.12 7.114 11 7.62 11 7.956c0 1.167.865 2 2 2s2-.833 2-2c0-.336-.121-.842-.435-1.508-.303-.644-.727-1.314-1.182-1.94A18.816 18.816 0 0 0 13 4c-.126.162-.255.331-.383.507-.455.627-.879 1.297-1.182 1.941z" />
  </svg>
);
export default IconDropSizeS;
